/**
* @Author: zachalam
* @Date:   2017-01-19T17:00:10-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-19T17:00:44-08:00
*/

import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import SearchHome from '../components/pages/Search/SearchHome';
import { connect } from 'react-redux';
import { getSearchIndexSection, clearSearch, resetFilters, saveFilters } from '../actions/searchActions';
import { favToggle, favToggleHome } from '../actions/favActions';
import { joinTrip, favTripInHome } from '../actions/tripActions';

class SearchHomeContainer extends Component {

  componentDidMount() {
    this.props.getSearchIndexSection('search_explore_members');
    this.props.getSearchIndexSection('search_upcoming_trips');
    //this.props.getSearchIndexSection('search_top_destinations');
    this.props.getSearchIndexSection('search_people_near_me');
  }


  render() {
    return (
      <SearchHome {...this.props} />
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    search: state.search,
  }
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {
    getSearchIndexSection: (which_section) => {
      dispatch(getSearchIndexSection(which_section));
    },
    saveFilters: (formData) => {
      dispatch(saveFilters({formData}));
      browserHistory.push("/search/results");
    },
    favToggle: (username) => {
      // notify api
      dispatch(favToggle(username));
      // notify store
      dispatch(favToggleHome(username));
    },
    joinTrip: (tripId,index) => {
      // notify api
      dispatch(joinTrip(tripId));  
      // notify store
      dispatch(favTripInHome(index));          
    },
    dropInSearchResults: (filterMembersLivingIn,formData) => {
      dispatch(clearSearch());
      dispatch(resetFilters());
      dispatch(saveFilters({filterMembersLivingIn,formData}));
      browserHistory.push("/search/results");
    }
  
  }
}

export default connect(mapStateTopProps,mapDispatchToProps)(SearchHomeContainer);



// WEBPACK FOOTER //
// ./src/containers/SearchHomeContainer.jsx